import { createClient, gql } from 'urql'

import { Practice, Query } from './generated-types/custom-graphql'
import { gqlClientOptions } from './base'
import { RequestLevel } from '../constants'

/** @deprecated [DASH-8895] Use GET_CONSOLIDATED_PRACTICES_SLIM_QUERY instead. */
export const PRACTICE_LIST_QUERY = gql<Query>(`
  query GetPractices ($skip: Int, $take: Int, $orderBy: [PracticeOrderByInput!], $where: PracticeWhereInput) {
    practices (orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      stripeAccountId
      name
      city
      state
      address
      zip
    }
  }
`)

/** @deprecated [DASH-8895] Use GET_CONSOLIDATED_PRACTICES_QUERY instead. */
export const ALL_PRACTICE_LIST_WITH_COUNT_QUERY = gql<Query>(`
  query GetAllPracticesCount ($skip: Int, $take: Int, $orderBy: [PracticeOrderByInput!], $where: PracticeWhereInput) {
    practicesWithCount (orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      items {
        id
        stripeAccountId
        consolidatorId
        name
        country
        city
        state
        address
        zip
        vetClinicId
        settings
        integrationId
        hospitalManagerEmail
        products
        routingNumber
        accountNumber
        logoUrl
        activeTerminalsCount
        totalTerminalsCount
        currentPims
        timezone
				isCustomPayoutEnabled
          consolidator {
          id
          featureFlags
        }
        netsuiteId
        skyworldId
      }
      total
    }
  }
`)

/** @deprecated [DASH-8895] Use GET_CONSOLIDATED_PRACTICES_QUERY instead. */
export const ALL_PRACTICE_LIST_QUERY = gql<Query>(`
  query GetAllPractices ($skip: Int, $take: Int, $orderBy: [PracticeOrderByInput!], $where: PracticeWhereInput) {
    practices (orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      stripeAccountId
      consolidatorId
      name
      country
      city
      state
      address
      zip
      vetClinicId
      settings
      integrationId
      hospitalManagerEmail
      products
      routingNumber
      accountNumber
      logoUrl
      activeTerminalsCount
      totalTerminalsCount
      currentPims
      timezone
      isCustomPayoutEnabled
      customPayoutTarget
      customPayoutSettings
      consolidator {
        id
        featureFlags
      }
      netsuiteId
      skyworldId
    }
  }
`)

/** @deprecated [DASH-8895] Use usePracticesForUser hook instead. */
export const usePracticesByHospitalManager = async (
	isAdmin: boolean,
	isRegionalManager: boolean,
	userId?: string,
	practiceId?: string,
	consolidatorId?: string
): Promise<Practice[]> => {
	const client = createClient(
		gqlClientOptions({
			requestLevel: isAdmin ? RequestLevel.ADMIN : RequestLevel.PRACTICE,
			practiceId,
			consolidatorId
		})
	)

	const result = await client
		.query(PRACTICE_LIST_QUERY, {
			take: null,
			where: {
				OR: [
					// Include practices where the user is a regional manager
					...(isRegionalManager && userId ? [{ regionalManagerId: { equals: userId } }] : []),
					// If the user is an admin, include practices for the specified consolidator
					...(isAdmin && consolidatorId ? [{ consolidatorId: { equals: consolidatorId } }] : []),
					// Otherwise, include practices where the user is a hospital manager
					...(!isAdmin && userId
						? [
								{
									users: {
										some: {
											userId: { equals: userId },
											isHospitalManager: true
										}
									}
								}
							]
						: [])
				]
			},
			orderBy: { name: 'asc' }
		})
		.toPromise()

	if (result.data?.practices) {
		return result.data.practices
	}

	return []
}
